import { queryOptions, useQuery } from '@tanstack/vue-query';
import type { ApiAuthorPage } from '@/types';

export function authorQueryOptions(id: number) {
  const { cmsFetch } = useCms();
  return queryOptions({
    queryKey: ['cms', 'pages', 'author', id] as const,
    queryFn: () => cmsFetch<ApiAuthorPage>(`/api/pages/${id}/`),
  });
}

export function useAuthor(id: MaybeRefOrGetter<number | undefined>) {
  const { cmsFetch } = useCms();
  const resolvedId = computed(() => toValue(id));

  const query = useQuery({
    queryKey: computed(() => ['cms', 'pages', 'author', resolvedId.value] as const),
    queryFn: () => cmsFetch<ApiAuthorPage>(`/api/pages/${resolvedId.value}/`),
    enabled: computed(() => !!resolvedId.value),
  });

  const author = computed(() => {
    const block = query.data.value?.body[0];
    return {
      ...block,
      name: `${block?.value?.first_name ?? ''} ${block?.value?.last_name ?? ''}`.trim(),
    };
  });

  return { ...query, author };
}
